export default function ({ redirect, store }) {
    const { isAdmin, isOwner, isLoggedIn } = store.getters;

    if (!isLoggedIn || !(isAdmin || isOwner)) {
        return redirect('/');
    }
}
